import React from 'react';
import PropTypes from 'prop-types';
import { Field, CccisdInput, CccisdWysiwyg } from 'cccisd-formik';
import { BuilderBlock, reportTemplateBuilder } from 'cccisd-laravel-appdefs';
import ColorPicker from '../../components/ColorPicker';
import filterFields from '../filterFields.js';
import widgets from '../widgets/index.js';

export const initialValues = {
    filterFields: filterFields.map(item => item.name),
    otherFilterOptions: [],
    colors: { primary: '#3673b6' },
    header: {
        title: 'Baseline Assessments Report',
        subtitle: 'SCHOOL',
        learnerText: 'Student Name (ID):',
        referralInterviewDateText: 'Referral Interview:',
        preTreatmentInterviewDateText: 'Pre-Treatment Interview:',
        createdDateText: 'Report Created On:',
        description:
            'This report provides assessment data from the Child Referral Interview and child Pre-Treatment Interview. Data from this report is used to support student eligibility determination for enrollment in an Act and Adapt Group.',
        gradeText: 'Grade:',
        referralInterviewerText: 'Referral Interviewer:',
        preTreatmentInterviewerText: 'Pre-Treatment Interviewer:',
    },
    body: {
        heading: '',
    },
    widgets: widgets.reduce((obj, w) => {
        obj[w.handle] = w.builderInitialValues;
        return obj;
    }, {}),
};

const Component = props => {
    return (
        <div>
            <BuilderBlock title="Header">
                <Field name="header.title" component={CccisdInput} label="Title" />
                <Field name="header.subtitle" component={CccisdInput} label="Subtitle" />
                <Field name="header.description" component={CccisdInput} label="Description" />
                <Field
                    name="header.referralInterviewDateText"
                    component={CccisdInput}
                    label="Referral Interview Date Text"
                />
                <Field
                    name="header.preTreatmentInterviewDateText"
                    component={CccisdInput}
                    label="Pre-Treatment Interview Date Text"
                />
                <Field
                    name="header.createdDateText"
                    component={CccisdInput}
                    label="Created Date Text"
                />
                <BuilderBlock title="Subheader">
                    <Field name="header.learnerText" component={CccisdInput} label="Learner Text" />
                    <Field name="header.learnerText" component={CccisdInput} label="Learner Text" />
                    <Field name="header.gradeText" component={CccisdInput} label="Grade Text" />
                    <Field
                        name="header.referralInterviewerText"
                        component={CccisdInput}
                        label="Referral Interviewer Text"
                    />
                    <Field
                        name="header.preTreatmentInterviewerText"
                        component={CccisdInput}
                        label="Pre-Treatment Interviewer Text"
                    />
                </BuilderBlock>
            </BuilderBlock>
            <BuilderBlock title="Body">
                <Field name="body.heading" component={CccisdWysiwyg} label="Page Heading" />
            </BuilderBlock>
            <BuilderBlock title="Color">
                <Field name="colors.primary">
                    {({ field, form }) => {
                        return <ColorPicker field={field} form={form} />;
                    }}
                </Field>
            </BuilderBlock>
        </div>
    );
};

Component.propTypes = {
    onValidChange: PropTypes.func,
    settings: PropTypes.object,
};

export default reportTemplateBuilder({ filterFields, widgets })(Component);
